import KButton from 'app/components/Modules/General/KButton'
import Button from 'app/components/UI-Elements/General/Button'
import { RecordType } from 'app/constants/GlobalTypes'
import { notify } from 'app/lib/Notify'
import { logoutUser } from 'app/redux/actions/__legacy/User'
import { ComponentProps, useState } from 'react'

const Logout: React.FC<ComponentProps<typeof Button>> = (props) => {
  const [loading, setLoading] = useState(false)

  const onClick = () => {
    setLoading(true)
    logoutUser().catch((err: string) => {
      notify({ message: err, intent: 'danger' })
      setLoading(false)
    })
  }

  return (
    <KButton
      onClick={onClick}
      recordType={RecordType.user}
      action="logout"
      type="secondary"
      loading={loading}
      {...props}
    />
  )
}

export default Logout
